import Core                         from '@/core/Core';
import CharacteristicAllowedValue   from '@/domains/Characteristics/CharacteristicAllowedValue';
import CharacteristicAllowedValuesDAO from '@/domains/Characteristics/CharacteristicAllowedValuesDAO';

import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';

class CharacteristicAllowedValuesService {

	static async get(id: number): Promise<CharacteristicAllowedValue | null> {
		const result = (await this.getList({ id })).data;
		return result[0] ?? null;
	}

	static async getListPaginated(
    params?: Parameters<typeof CharacteristicAllowedValuesDAO.getList>[0] & {
      pagination?: RpcDataPagination,
      sort?: RpcDataSort,
    }
  ): Promise<{ data: CharacteristicAllowedValue[]; pagination: RpcDataPagination }> {
		const { pagination, sort, ...filters } = params ?? {};
		const response = await CharacteristicAllowedValuesDAO.getList(filters, pagination, sort);

		return {
			data: Core.utils.hydrateArray(response.data, CharacteristicAllowedValue.fromServer),
			pagination: response.meta.pagination,
		};
	}

	static async getList(
    params?: Parameters<typeof CharacteristicAllowedValuesDAO.getList>[0]
  ): Promise<{ data: CharacteristicAllowedValue[] }> {
		const result = await this.getListPaginated(params);
		return { data: result.data };
	}

	static async add(characteristicId: number, name: string): Promise<boolean> {
		const response = await CharacteristicAllowedValuesDAO.add(characteristicId, name);

		if (response.ok) {
			Core.showNotification.success('Допустимое значение добавлено');
		}

		return response.ok;
	}

	static async update(value: CharacteristicAllowedValue): Promise<boolean> {
		const response = await CharacteristicAllowedValuesDAO.update(value);

		if (response.ok) {
			Core.showNotification.success('Допустимое значение обновлено');
		}

		return response.ok;
	}

	static async delete(id: number): Promise<boolean> {
		const response = await CharacteristicAllowedValuesDAO.delete(id);

		if (response.ok) {
			Core.showNotification.success('Допустимое значение удалено');
		}

		return response.ok;
	}
}

export default CharacteristicAllowedValuesService;
